import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, Button } from 'antd';

import StandardContainer from '../../../../../shared/components/otop/StandardContainer';
import CardWrapper from '../../../../../shared/components/otop/CardWrapper';
import TableTag from '../components/TableTag';
import { getTagList, deleteTag } from '../actions';

export default function LandingTag() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { tags, loading } = state.tag;

  useEffect(() => {
    dispatch(getTagList());
  }, []);

  return (
    <StandardContainer>
      <div className="main-container">
        <div className="content-bg my-5">
          <CardWrapper>
            <Card className="card">
              <div className="flex justify-between card-content">
                <p>Product tags are listed here</p>
                <Link to="/otop-hub/admin/tags/add">
                  <Button className="flex items-center">
                    <i className="fas fa-edit mr-2 text-lg"></i>
                    Add Tag
                  </Button>
                </Link>
              </div>
              <div className="card-content">
                <TableTag
                  tags={tags}
                  loading={loading}
                  getTagList={getTagList}
                  deleteTag={deleteTag}
                />
              </div>
            </Card>
          </CardWrapper>
        </div>
      </div>
    </StandardContainer>
  );
}
